import * as React from 'react'
import { connect } from 'react-redux'

import { LOGO } from 'components/_Assets/svg/Icon/logo'
import Announcement, {
  AnnouncementType,
} from 'components/Announcement/Announcement'
import { Colour } from 'components/variables'
import { City } from '../../../data/models/funnelOrder/cities'
import { AppState } from '../../../data/state'
import AbstractTrigger from '../abstractTrigger'

interface BucketListTriggerProps {
  includedCities: City[]
  showLength: number
  colour?: Colour
  onClose?: () => void
  children?: React.ReactNode | undefined
}

interface BucketListTriggerState {
  show: boolean
}

class BucketListTrigger extends AbstractTrigger<
  BucketListTriggerProps,
  BucketListTriggerState
> {
  public timerLength = 10000
  private prevLength: number
  constructor(props: BucketListTriggerProps) {
    super(props)
    this.state = {
      show: false,
    }
    this.prevLength = props.includedCities.length
    this.handleClose = this.handleClose.bind(this)
  }

  public updateShow(props: BucketListTriggerProps) {
    const citiesLength = props.includedCities.length
    const currentLength = citiesLength
    if (currentLength !== this.prevLength) {
      if (currentLength === this.props.showLength) {
        this.setState({ show: true })
        this.startTimer(false)
      }
      this.prevLength = citiesLength
    }
  }

  public handleClose() {
    const { onClose } = this.props
    if (onClose) {
      onClose()
    }
    this.onClose()
  }

  public render() {
    const { colour, children } = this.props
    const { show } = this.state

    return (
      <Announcement
        type={AnnouncementType.Info}
        show={show}
        icon={LOGO.logo}
        colour={colour}
        onClose={this.handleClose}
      >
        {children}
      </Announcement>
    )
  }
}

export default connect((state: AppState) => ({
  includedCities: state.funnelOrder.includedCitiesIds,
}))(BucketListTrigger)
